import { v4 as uuidv4 } from "uuid";

export const updatePageIds = () => {
  const current_page_id = sessionStorage.getItem("current_page_id");
  sessionStorage.setItem("current_page_id", uuidv4());
  sessionStorage.setItem("previous_page_id", current_page_id);
};
